"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContextProvider = exports.ModalContext = exports.defaultModalContext = void 0;

var _react = require("react");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var defaultModalContext = {
  use: 'default',
  headerCallback: _emptyFunction.default
};
exports.defaultModalContext = defaultModalContext;
var ModalContext = (0, _react.createContext)(defaultModalContext);
exports.ModalContext = ModalContext;
var Provider = ModalContext.Provider;
exports.ModalContextProvider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/context/ModalContext.js
// module id = 408
// module chunks = 5 6